import { useCallback, useState } from 'react'

import type { Shipment } from '../../domain/Shipment'
import { AssignDriverCardContent } from './AssignDriverCardContent'
import { AssignDriverDialog } from './AssignDriverDialog'
import { DriverAssignedCardContent } from './DriverAssignedCardContent'
import { UnassignDriverDialog } from './UnassignDriverDialog'

type AssignDriverCardProps = {
  readonly shipment: Shipment
  readonly onDriverChanged: (uuid: string) => void
}

type DriverDialogs = 'assignDriver' | 'unassignDriver'

export function AssignDriverCard({ shipment, onDriverChanged }: AssignDriverCardProps) {
  const [openDialog, setOpenDialog] = useState<DriverDialogs | null>(null)

  const handleDriverChanged = useCallback(() => {
    onDriverChanged(shipment.uuid)
  }, [onDriverChanged, shipment.uuid])

  return (
    <>
      {shipment.driver ? (
        <DriverAssignedCardContent
          driver={shipment.driver}
          onClickEditDriver={() => setOpenDialog('assignDriver')}
          onClickUnassignDriver={() => setOpenDialog('unassignDriver')}
        />
      ) : (
        <AssignDriverCardContent onClick={() => setOpenDialog('assignDriver')} />
      )}

      {openDialog === 'assignDriver' && (
        <AssignDriverDialog
          open
          onClose={() => setOpenDialog(null)}
          carrierUUID={shipment.carrier.uuid}
          driverUUID={shipment.driver?.uuid}
          shipmentUUID={shipment.uuid}
          onDriverAssigned={handleDriverChanged}
        />
      )}
      {openDialog === 'unassignDriver' && (
        <UnassignDriverDialog
          open
          onClose={() => setOpenDialog(null)}
          shipmentUUID={shipment.uuid}
          onDriverUnassigned={handleDriverChanged}
        />
      )}
    </>
  )
}
